import React from "react";
import {  Toast } from "primereact";

class Stabilimento extends React.Component {
  showMessage(messageError, tipo) {
    var icona = "";
    if (tipo == "error") {
      icona = "pi pi-times-circle";
    }
    if (tipo == "info") {
      icona = "pipi-info-circle";
    }
    if (tipo == "success") {
      icona = "pi pi-check-circle";
    }
    if (tipo == "warning") {
      icona = "pi pi-exclamation-triangle";
    }
    this.toastBC.show({
      severity: tipo,
      life: 3000,
      closable: false,
      content: (
        <div className="flex flex-column" style={{ flex: "1" }}>
          <div className="text-center">
            <i className={icona} style={{ fontSize: "3rem" }}></i>
            <h4>{messageError}</h4>
          </div>
        </div>
      ),
    });
  }
  render() {
    return (
      <div className="flex">
        <Toast ref={(el) => (this.toastBC = el)} position="bottom-center" />
      </div>
    );
  }
}

export default Stabilimento;
